import React from 'react'
import { useSearchParams } from 'react-router-dom'
import BindPhoneModal from '@/pages/Personal/BindPhoneModal'
import { LoginBackground, LoginCard, LoginContent, LoginView } from '@/pages/Login/components'
import { useMobileView } from '@/hooks'

const BindPhonePage: React.FC = () => {
  const isMobile = useMobileView()
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get('redirect') || '/console/workbench'
  const goNext = () => {
    try {
      window.location.href = decodeURIComponent(redirect)
    } catch {
      window.location.href = '/console/workbench'
    }
  }

  return (
    <LoginView>
      {!isMobile && <LoginBackground />}
      {/* @ts-ignore */}
      <LoginContent sx={isMobile && { backgroundColor: '#fff', width: 'auto !important' }}>
        <LoginCard type='password'>
          <BindPhoneModal open onCancel={() => undefined} onOk={goNext} />
        </LoginCard>
      </LoginContent>
    </LoginView>
  )
}

export default BindPhonePage
